export function authHeader() {
    // return authorization header with jwt token
    const user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return { Authorization: 'Token ' + user.token };
    }
    return {};
}



// WEBPACK FOOTER //
// ./src/_helpers/auth-header.js